module.exports = __webpack_public_path__ + "h5/img/banner_5.87f63c5a.jpg";